import { FilterState } from "models/propTypes/filterPropTypes";
import React from "react";
import { FilterContext } from "./contextProvider";

function useFilterContext<T extends Record<string, any>>() {
  const context = React.useContext<FilterState<T>>(FilterContext);

  return context;
}

export default useFilterContext;
